import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  service;
  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    this.service = await this.getAdmin();
  }

  getAdmin(): Promise<any> {
    return this.db
      .doc$(`appService/HBJIDSBsZtIpe00tWiD5`)
      .pipe(
        map(data => {
          return data.serviceAreement;
        })
      )
      .pipe(first())
      .toPromise();
  }
}
